import React, { useEffect, useState } from 'react'
import ContentHeader from '../../../Layout/ContentHeader'
import Box from '../../../Global/Box'
import { useMutation, useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { useHistory, useParams } from 'react-router'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import InputController from '../../../Global/InputController'
import DynamicForm from '../../../Global/DynamicForm'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import {
  GET_ONE_MODULE,
  CREATE_MODULE,
  UPDATE_MODULE,
  ALL_MODULES,
} from '../../../../graphql/Catalog/Modules/modules'
import * as Yup from 'yup'

export const ModulesNew = () => {
  const { id: _id, show } = useParams()
  const { showLoading, hideLoading } = useLoading()

  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [icon, setIcon] = useState('')
  const [idsToDelete, setIdsToDelete] = useState([])
  const [iconSubmodule, setIconSubmodule] = useState('')

  const {
    data: dataModule,
    error: errorModule,
    loading: loadingModules,
  } = useQuery(GET_ONE_MODULE, {
    variables: {
      getOneModuleId: parseInt(_id),
    },
  })

  const [createModule] = useMutation(CREATE_MODULE, {
    refetchQueries: [
      {
        query: ALL_MODULES,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
      {
        query: ALL_MODULES,
        variables: {
          limit: null,
          offset: null,
        },
      },
    ],
  })

  const [updateModule] = useMutation(UPDATE_MODULE, {
    refetchQueries: [
      {
        query: ALL_MODULES,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
      {
        query: ALL_MODULES,
        variables: {
          limit: null,
          offset: null,
        },
      },
      {
        query: GET_ONE_MODULE,
        variables: { getOneModuleId: parseInt(_id) },
      },
    ],
  })

  const validationSchema = Yup.object().shape({
    frontLabel: Yup.string().required('Campo requerido'),
    moduleName: Yup.string().required('Campo requerido'),
    relativeLink: Yup.string().required('Campo requerido'),
    icon: Yup.string().required('Campo requerido'),
    submodules: Yup.array().of(
      Yup.object().shape({
        submoduleName: Yup.string().required('Campo requerido'),
        frontLabelSubmodule: Yup.string().required('Campo requerido'),
        relativeLinkSubmodule: Yup.string().required('Campo requerido'),
        iconSubmodule: Yup.string().required('Campo requerido'),
      })
    ),
  })

  const {
    methods,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(validationSchema) })

  useEffect(() => {
    if (_id) {
      if (!loadingModules) {
        if (errorModule)
          return toastSweetAlert({
            mode: 'error',
            message: errorModule.message,
          })

        if (dataModule !== undefined && dataModule !== null) {
          const data = dataModule.getOneModule
          setIcon(`fas fa-${data.icon}`)
          const submodules = data.submodules.map((submodule, idx) => {
            setIconSubmodule({
              ...iconSubmodule,
              [`submodules[${idx}].iconSubmodule`]: `fas fa-${submodule.icon}`,
            })
            return {
              id: submodule.id,
              submoduleName: submodule.name,
              relativeLinkSubmodule: submodule.relative_link,
              frontLabelSubmodule: submodule.front_label,
              iconSubmodule: submodule.icon,
            }
          })
          const dataFormated = {
            moduleName: data.name,
            frontLabel: data.front_label,
            relativeLink: data.relative_link,
            icon: data.icon,
            submodules: submodules,
          }
          reset(dataFormated)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataModule, errorModule, loadingModules, reset, _id])

  const onSubmit = async (data) => {
    // setLoading(true)
    const submodules = data.submodules.map((submodule) => {
      return {
        id: typeof submodule.id === 'number' ? parseInt(submodule.id) : 0,
        name: submodule.submoduleName,
        relative_link: submodule.relativeLinkSubmodule,
        front_label: submodule.frontLabelSubmodule,
        icon: submodule.iconSubmodule,
      }
    })

    showLoading()

    try {
      if (_id) {
        await updateModule({
          variables: {
            moduleId: parseInt(_id),
            moduleInput: {
              name: data.moduleName,
              relative_link: data.relativeLink,
              front_label: data.frontLabel,
              icon: data.icon,
            },
            submodulesIdsTodelete: idsToDelete,
            submoduleInput: submodules,
          },
        })
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Modulo ha sido actualizado correctamente',
          },
          history.push(`/modules`)
        )
      } else {
        await createModule({
          variables: {
            moduleInput: {
              name: data.moduleName,
              relative_link: data.relativeLink,
              front_label: data.frontLabel,
              icon: data.icon,
            },
            submoduleInput: submodules,
          },
        })
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Modulo ha sido creado correctamente',
          },
          history.push(`/modules`)
        )
      }
    } catch (error) {
      setLoading(false)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title="Gestión de módulos"
        breadcrumb="Módulos"
        windowTitle={`${_id ? 'Editar' : 'Agregar'} módulo `}
      />
      <FormProvider {...methods}>
        <form className="px-2 pb-3" onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`${_id ? (show ? 'Detalles': 'Editar') : 'Agregar'} módulo`}
            btnRedPath="/modules"
            btnRedTxt="Cancelar"
            btnSubmit={!show}
            btnState={loading}
            errors={errors}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-12">
                    <h2>Módulo principal</h2>
                  </div>
                  <div className="mb-3 col-12">
                    <hr />
                  </div>
                  <div className="mb-3 col-md-12 col-lg-3">
                    <InputController
                      label="Etiqueta"
                      type="text"
                      name="frontLabel"
                      placeholder="Escribe el nombre del módulo en el menú"
                      control={control}
                      disabled={show}
                    />
                  </div>
                  <div className="mb-3 col-md-12 col-lg-3">
                    <InputController
                      label="Módulo nombre"
                      type="text"
                      name="moduleName"
                      placeholder="Módulo nombre"
                      control={control}
                      disabled={show}
                    />
                  </div>
                  <div className="mb-3 col-md-12 col-lg-3">
                    <InputController
                      label="Link"
                      type="text"
                      name="relativeLink"
                      placeholder="Inserta enlace de módulo"
                      control={control}
                      disabled={show}
                    />
                  </div>
                  <div className="mb-3 col-md-12 col-lg-3">
                    <label>Icono</label>
                    <div className="input-group">
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          id="inputGroupAppend"
                        >
                          <i className={icon}></i>
                        </span>
                      </div>
                      <InputController
                        type="text"
                        name="icon"
                        placeholder="FontAwesome icon"
                        aria-describedby="inputGroupAppend"
                        control={control}
                        changeAction={(e) =>
                          setIcon(`fas fa-${e.target.value}`)
                        }
                        disabled={show}
                      />
                    </div>
                  </div>
                  <div className="mb-3 mt-3 col-12">
                    <h2>Sub-módulo</h2>
                  </div>
                  <div className="mb-3 col-12">
                    <hr />
                  </div>
                </div>
                <div className="row">
                  <DynamicForm
                    control={control}
                    btnAppendTxt={'Añadir submódulo'}
                    emptyText="No hay submódulos"
                    iconSubmodule={iconSubmodule} //PARA MI MÓDULO CUSTOM, NO ES NECESARIO
                    prefix="submodules"
                    idsToDelete={idsToDelete}
                    setIdsToDelete={setIdsToDelete}
                    disabled={show}
                    inputs={[
                      {
                        name: 'id',
                        type: 'hidden',
                      },
                      {
                        name: 'frontLabelSubmodule',
                        label: 'Etiqueta',
                        type: 'text',
                        placeholder:
                          'Escribe el nombre del submódulo en el menú',
                        colSize: 3,
                        disabled: show,
                      },
                      {
                        name: 'submoduleName',
                        label: 'Sub-módulo nombre',
                        type: 'text',
                        placeholder: 'Nombre de submódulo',
                        colSize: 3,
                        disabled: show,
                      },
                      {
                        name: 'relativeLinkSubmodule',
                        label: 'Link',
                        type: 'text',
                        placeholder: 'Sub-módulo link',
                        colSize: 3,
                        disabled: show,
                      },
                      {
                        name: 'iconSubmodule',
                        label: 'Sub-módulo icono',
                        type: 'text',
                        placeholder: 'FontAwesome icon',
                        iconState: setIconSubmodule, //PARA MI MÓDULO CUSTOM
                        specialSubmodule: true, //PARA MI MÓDULO CUSTOM
                        colSize: 3,
                        disabled: show,
                      },
                    ]}
                  />
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default ModulesNew
